import { registerPlugin } from '@capacitor/core'

interface PresentData {
	viewName: string
	models?: any[]
	assessmentSupportedIcd10s?: string[]
	priorIcd10s?: string[]
	scanMode?: string
	isDebugMode?: boolean
	barcodeType?: string
}

interface SwiftUIViewInterface {
	present(data: PresentData): Promise<void>
}

const SwiftUIView = registerPlugin<SwiftUIViewInterface>('SwiftUIView')

export default SwiftUIView